var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"site",attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"site__content"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('router-view')],1)])]),_c('app-notifications'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }